import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { END_POINTS } from "../../Helper/Constant";
import { getApiRequest } from "../../services/getApiRequest";
import { showLoader, hideLoader } from "../loader/loaderSlice";

export const fetchEventData = createAsyncThunk(
  "event/fetchEventData",
  async ({ id, userId }, { dispatch, rejectWithValue }) => {
    dispatch(showLoader());
    try {
      const url = `${END_POINTS.GET_EVENT_BY_ID}/${id}${userId ? `?userId=${userId}` : ""}`;
      const response = await getApiRequest(url);
      return response.event;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    } finally {
      dispatch(hideLoader());
    }
  }
);

export const fetchHasActiveEvents = createAsyncThunk(
  "event/fetchHasActiveEvents",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getApiRequest(END_POINTS.EVENTS_HAS_ACTIVE);
      return response?.hasActiveEvents || false;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const eventSlice = createSlice({
  name: "event",
  initialState: {
    data: null,
    status: "idle",
    error: null,
    hasActiveEvents: false,
    hasActiveEventsFromSocket: false,
  },
  reducers: {
    clearEventData: (state) => {
      state.data = null;
      state.status = "idle";
      state.error = null;
    },
    setHasActiveEventsFromSocket: (state, action) => {
      state.hasActiveEvents = Boolean(action.payload);
      state.hasActiveEventsFromSocket = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEventData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchEventData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(fetchEventData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(fetchHasActiveEvents.fulfilled, (state, action) => {
        if (!state.hasActiveEventsFromSocket) {
          state.hasActiveEvents = Boolean(action.payload);
        }
      });
  },
});

export const { clearEventData, setHasActiveEventsFromSocket } = eventSlice.actions;
export default eventSlice.reducer;
